/**
 * Author: Fleming Shi
 * Project: DAL (Digital Abstraction Layer)
 * Date: 2026-04-30
 * Description: Simple post-registration confirmation page. Reachable as a
 *              real URL (so refresh doesn't reset the form) — the register
 *              page navigates here on successful submit.
 */

import React from 'react'
import { Link, useSearchParams } from 'react-router-dom'

const ApiAccessRegistered: React.FC = () => {
  const [params] = useSearchParams()
  const email = params.get('email') ?? ''

  return (
    <div className="mx-auto max-w-xl py-16">
      <div className="rounded-lg border border-green-200 bg-green-50 p-6 dark:border-green-800/50 dark:bg-green-950/30">
        <h1 className="text-xl font-semibold text-green-900 dark:text-green-300">Request submitted</h1>
        <p className="mt-2 text-sm text-green-800 dark:text-green-300">
          Thanks
          {email ? (
            <>
              , we&apos;ve emailed a confirmation to <span className="font-medium">{email}</span>
            </>
          ) : null}
          . A Comcast Business DAL-ify administrator will review your request shortly. When approved, you&apos;ll
          receive a second email with a 6-digit verification code.
        </p>
        <p className="mt-3 text-xs text-green-700 dark:text-green-400">You can close this page.</p>
      </div>

      <p className="mt-8 text-sm text-gray-500 dark:text-gray-400">
        Already verified?{' '}
        <Link className="text-indigo-600 underline dark:text-indigo-400" to="/api-access/login">
          Sign in
        </Link>
        .
      </p>
    </div>
  )
}

export default ApiAccessRegistered
